<header id="header">
    <!-- Navbar -->
    <nav data-aos="zoom-out" data-aos-delay="800" class="navbar navbar-expand">
        <div class="container header">
            <!-- Navbar Brand-->
            <a class="navbar-brand" href="/">
                <img class="navbar-brand-regular" src="assets/img/logo-white.png" alt="brand-logo" style="width: 150px;margin-top: -25px; margin-bottom: -25px;">
                <img class="navbar-brand-sticky" src="assets/img/logo.png" alt="sticky brand-logo" style="width: 150px;margin-top: -25px; margin-bottom: -25px;">
            </a>
            <div class="ml-auto"></div>
            <!-- Navbar -->
            <ul class="navbar-nav items">
                <li class="nav-item" *ngFor="let menuItem of menuItems">
                    <a  [routerLink]="[menuItem.link]" class="nav-link">{{menuItem.name}}</a>
                </li>
            </ul>
            
            <!-- Navbar Toggler -->
            <ul class="navbar-nav toggle">
                <li class="nav-item">
                    <a href="#" class="nav-link" data-toggle="modal" data-target="#menu">
                        <i class="fas fa-bars toggle-icon m-0"></i>
                    </a>
                </li>
            </ul>

            <!-- Navbar Action Button -->
            <ul class="navbar-nav action">
                <li class="nav-item ml-3">
                    <a class="btn ml-lg-auto btn-bordered-white" (click)="openContactModal()"><i class="fas fa-paper-plane contact-icon mr-md-2"></i>Free Consultation</a>
                </li>
            </ul>
        </div>
    </nav>
</header>